/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_LabelInputs */

const en_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Provider`)
};

const fr_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur de service`)
};

const de_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstleister`)
};

const it_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore di servizi`)
};

const ru_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик услуг`)
};

const es_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor de servicios`)
};

const zh_cn2_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务提供商`)
};

const ja_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスプロバイダー`)
};

const hi_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेवा प्रदाता`)
};

const pt_pt2_voice_manager_provider_label = /** @type {(inputs: Voice_Manager_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestador de Serviços`)
};

/**
* | output |
* | --- |
* | "Service Provider" |
*
* @param {Voice_Manager_Provider_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_label = /** @type {((inputs?: Voice_Manager_Provider_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_label(inputs)
	if (locale === "de") return de_voice_manager_provider_label(inputs)
	if (locale === "it") return it_voice_manager_provider_label(inputs)
	if (locale === "ru") return ru_voice_manager_provider_label(inputs)
	if (locale === "es") return es_voice_manager_provider_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_label(inputs)
	if (locale === "ja") return ja_voice_manager_provider_label(inputs)
	if (locale === "hi") return hi_voice_manager_provider_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_label(inputs)
	return en_voice_manager_provider_label(inputs)
});